import { InvoiceUploaderGuard } from './invoice-uploader.guard';

export const guards = [InvoiceUploaderGuard];

export * from './invoice-uploader.guard';
